// Fyntrak Equity Portfolio 1× daily equity curve — ingested reference data.
// Source: Fyntrak dashboard export (equity_portfolio_1x_daily.csv), through 2026-06-18.
// OG Equity Portfolio keeps THIS frozen history through the last export date, then stitches
// live equal-weight OG stock legs from the `/api/webhooks/tradingview-stocks/og` feed.
// OG 2.25× applies linear or compounded leverage to that blended 1× series.
// To refresh the frozen baseline: re-export the 1× daily curve from Fyntrak and regenerate
// this file AND server/data/fyntrakOgEquityCurve.json (Railway reads the JSON copy).
export const FYNTRAK_OG_EQUITY_1X_CURVE = [
  { date: '2021-12-31', equity: 100000 },
  { date: '2022-01-03', equity: 100085.8 },
  { date: '2022-01-04', equity: 100085.8 },
  { date: '2022-01-05', equity: 99586.15 },
  { date: '2022-01-07', equity: 99586.15 },
  { date: '2022-01-10', equity: 99617.62 },
  { date: '2022-01-11', equity: 99617.62 },
  { date: '2022-01-12', equity: 99617.62 },
  { date: '2022-01-13', equity: 99617.62 },
  { date: '2022-01-14', equity: 99617.62 },
  { date: '2022-01-17', equity: 99617.62 },
  { date: '2022-01-18', equity: 99617.62 },
  { date: '2022-01-19', equity: 99617.62 },
  { date: '2022-01-20', equity: 99617.62 },
  { date: '2022-01-21', equity: 100408.29 },
  { date: '2022-01-24', equity: 100419.92 },
  { date: '2022-01-25', equity: 100419.92 },
  { date: '2022-01-27', equity: 100419.92 },
  { date: '2022-01-28', equity: 100445.6 },
  { date: '2022-01-31', equity: 101282.1 },
  { date: '2022-02-02', equity: 102363.97 },
  { date: '2022-02-03', equity: 102363.97 },
  { date: '2022-02-04', equity: 103109.89 },
  { date: '2022-02-07', equity: 103109.89 },
  { date: '2022-02-08', equity: 103109.89 },
  { date: '2022-02-09', equity: 103109.89 },
  { date: '2022-02-10', equity: 103109.89 },
  { date: '2022-02-11', equity: 103109.89 },
  { date: '2022-02-14', equity: 103109.89 },
  { date: '2022-02-15', equity: 103109.89 },
  { date: '2022-02-16', equity: 103109.89 },
  { date: '2022-02-17', equity: 103133.67 },
  { date: '2022-02-18', equity: 103226.76 },
  { date: '2022-02-22', equity: 103321.49 },
  { date: '2022-02-23', equity: 103321.49 },
  { date: '2022-02-24', equity: 103321.49 },
  { date: '2022-02-25', equity: 103321.49 },
  { date: '2022-02-28', equity: 103321.49 },
  { date: '2022-03-01', equity: 103321.49 },
  { date: '2022-03-02', equity: 103321.49 },
  { date: '2022-03-03', equity: 103321.49 },
  { date: '2022-03-04', equity: 103321.49 },
  { date: '2022-03-08', equity: 103321.49 },
  { date: '2022-03-09', equity: 103321.49 },
  { date: '2022-03-10', equity: 104420.57 },
  { date: '2022-03-11', equity: 104420.57 },
  { date: '2022-03-14', equity: 103853.92 },
  { date: '2022-03-16', equity: 103853.92 },
  { date: '2022-03-17', equity: 103853.92 },
  { date: '2022-03-21', equity: 104740.33 },
  { date: '2022-03-22', equity: 104216.45 },
  { date: '2022-03-23', equity: 105028.06 },
  { date: '2022-03-24', equity: 105028.06 },
  { date: '2022-03-25', equity: 105028.06 },
  { date: '2022-03-28', equity: 106013.97 },
  { date: '2022-03-29', equity: 106718.29 },
  { date: '2022-03-30', equity: 106718.29 },
  { date: '2022-03-31', equity: 106718.29 },
  { date: '2022-04-01', equity: 106718.29 },
  { date: '2022-04-04', equity: 106831.72 },
  { date: '2022-04-05', equity: 106749.16 },
  { date: '2022-04-06', equity: 106749.16 },
  { date: '2022-04-07', equity: 106749.16 },
  { date: '2022-04-08', equity: 106749.16 },
  { date: '2022-04-11', equity: 106847.87 },
  { date: '2022-04-12', equity: 106257.29 },
  { date: '2022-04-13', equity: 106257.29 },
  { date: '2022-04-14', equity: 106257.29 },
  { date: '2022-04-18', equity: 106257.29 },
  { date: '2022-04-19', equity: 106257.29 },
  { date: '2022-04-20', equity: 106257.29 },
  { date: '2022-04-21', equity: 106176.99 },
  { date: '2022-04-22', equity: 106176.99 },
  { date: '2022-04-25', equity: 106904.09 },
  { date: '2022-04-26', equity: 106904.09 },
  { date: '2022-04-27', equity: 107008.55 },
  { date: '2022-04-28', equity: 107008.55 },
  { date: '2022-04-29', equity: 107840.23 },
  { date: '2022-05-03', equity: 107840.23 },
  { date: '2022-05-04', equity: 107840.23 },
  { date: '2022-05-05', equity: 107840.23 },
  { date: '2022-05-06', equity: 108619.48 },
  { date: '2022-05-09', equity: 109725.51 },
  { date: '2022-05-10', equity: 109725.51 },
  { date: '2022-05-11', equity: 109725.51 },
  { date: '2022-05-12', equity: 111255.53 },
  { date: '2022-05-13', equity: 111255.53 },
  { date: '2022-05-16', equity: 111255.53 },
  { date: '2022-05-17', equity: 111255.53 },
  { date: '2022-05-18', equity: 111255.53 },
  { date: '2022-05-20', equity: 111177.73 },
  { date: '2022-05-23', equity: 111177.73 },
  { date: '2022-05-24', equity: 111177.73 },
  { date: '2022-05-26', equity: 111177.73 },
  { date: '2022-05-27', equity: 111177.73 },
  { date: '2022-05-30', equity: 111177.73 },
  { date: '2022-05-31', equity: 111291.27 },
  { date: '2022-06-01', equity: 111291.27 },
  { date: '2022-06-02', equity: 111291.27 },
  { date: '2022-06-03', equity: 111291.27 },
  { date: '2022-06-06', equity: 112191.51 },
  { date: '2022-06-07', equity: 112191.51 },
  { date: '2022-06-08', equity: 112191.51 },
  { date: '2022-06-10', equity: 112191.51 },
  { date: '2022-06-13', equity: 113749.36 },
  { date: '2022-06-14', equity: 113660.43 },
  { date: '2022-06-15', equity: 112975.14 },
  { date: '2022-06-16', equity: 112975.14 },
  { date: '2022-06-17', equity: 112305.9 },
  { date: '2022-06-21', equity: 112305.9 },
  { date: '2022-06-23', equity: 112305.9 },
  { date: '2022-06-24', equity: 113229.13 },
  { date: '2022-06-27', equity: 113140.28 },
  { date: '2022-06-28', equity: 112488.87 },
  { date: '2022-06-29', equity: 112488.87 },
  { date: '2022-06-30', equity: 112420.86 },
  { date: '2022-07-05', equity: 112420.86 },
  { date: '2022-07-06', equity: 112420.86 },
  { date: '2022-07-07', equity: 112420.86 },
  { date: '2022-07-11', equity: 112260.04 },
  { date: '2022-07-12', equity: 112260.04 },
  { date: '2022-07-13', equity: 112260.04 },
  { date: '2022-07-14', equity: 112260.04 },
  { date: '2022-07-18', equity: 112260.04 },
  { date: '2022-07-19', equity: 112260.04 },
  { date: '2022-07-20', equity: 112260.04 },
  { date: '2022-07-21', equity: 112365.06 },
  { date: '2022-07-22', equity: 112365.06 },
  { date: '2022-07-25', equity: 112365.06 },
  { date: '2022-07-26', equity: 112288.75 },
  { date: '2022-07-27', equity: 112288.75 },
  { date: '2022-07-28', equity: 112288.75 },
  { date: '2022-07-29', equity: 113199.74 },
  { date: '2022-08-01', equity: 112680.64 },
  { date: '2022-08-02', equity: 112680.64 },
  { date: '2022-08-03', equity: 112680.64 },
  { date: '2022-08-04', equity: 112680.64 },
  { date: '2022-08-05', equity: 112724.24 },
  { date: '2022-08-08', equity: 113743.16 },
  { date: '2022-08-09', equity: 113876.52 },
  { date: '2022-08-10', equity: 114609.78 },
  { date: '2022-08-11', equity: 114609.78 },
  { date: '2022-08-12', equity: 114609.78 },
  { date: '2022-08-15', equity: 114609.78 },
  { date: '2022-08-16', equity: 114514.72 },
  { date: '2022-08-17', equity: 115372.73 },
  { date: '2022-08-18', equity: 115372.73 },
  { date: '2022-08-19', equity: 114723.73 },
  { date: '2022-08-22', equity: 114853.82 },
  { date: '2022-08-23', equity: 114853.82 },
  { date: '2022-08-24', equity: 114853.82 },
  { date: '2022-08-25', equity: 114853.82 },
  { date: '2022-08-26', equity: 115540.83 },
  { date: '2022-08-29', equity: 115540.83 },
  { date: '2022-08-30', equity: 116239.79 },
  { date: '2022-08-31', equity: 116239.79 },
  { date: '2022-09-01', equity: 117154.18 },
  { date: '2022-09-05', equity: 117154.18 },
  { date: '2022-09-06', equity: 117154.18 },
  { date: '2022-09-08', equity: 117154.18 },
  { date: '2022-09-09', equity: 117899.69 },
  { date: '2022-09-12', equity: 117899.69 },
  { date: '2022-09-13', equity: 117899.69 },
  { date: '2022-09-14', equity: 117899.69 },
  { date: '2022-09-15', equity: 117899.69 },
  { date: '2022-09-16', equity: 119284.83 },
  { date: '2022-09-19', equity: 119392.1 },
  { date: '2022-09-21', equity: 119392.1 },
  { date: '2022-09-22', equity: 119530.61 },
  { date: '2022-09-23', equity: 121307.24 },
  { date: '2022-09-26', equity: 121307.24 },
  { date: '2022-09-27', equity: 121307.24 },
  { date: '2022-09-28', equity: 121307.24 },
  { date: '2022-09-29', equity: 121307.24 },
  { date: '2022-09-30', equity: 122193.62 },
  { date: '2022-10-03', equity: 122366.58 },
  { date: '2022-10-04', equity: 122283.21 },
  { date: '2022-10-05', equity: 121509.29 },
  { date: '2022-10-06', equity: 121509.29 },
  { date: '2022-10-07', equity: 121625.02 },
  { date: '2022-10-10', equity: 122405.9 },
  { date: '2022-10-11', equity: 122405.9 },
  { date: '2022-10-12', equity: 122526.79 },
  { date: '2022-10-13', equity: 124076.99 },
  { date: '2022-10-14', equity: 124076.99 },
  { date: '2022-10-17', equity: 124076.99 },
  { date: '2022-10-18', equity: 124076.99 },
  { date: '2022-10-20', equity: 124076.99 },
  { date: '2022-10-21', equity: 124076.99 },
  { date: '2022-10-24', equity: 124076.99 },
  { date: '2022-10-25', equity: 124076.99 },
  { date: '2022-10-26', equity: 124076.99 },
  { date: '2022-10-27', equity: 124076.99 },
  { date: '2022-10-31', equity: 124076.99 },
  { date: '2022-11-01', equity: 124261.03 },
  { date: '2022-11-02', equity: 125313.37 },
  { date: '2022-11-03', equity: 125313.37 },
  { date: '2022-11-07', equity: 125588.87 },
  { date: '2022-11-08', equity: 125486.12 },
  { date: '2022-11-09', equity: 125486.12 },
  { date: '2022-11-10', equity: 127417.66 },
  { date: '2022-11-11', equity: 128305.94 },
  { date: '2022-11-14', equity: 128305.94 },
  { date: '2022-11-15', equity: 128515.41 },
  { date: '2022-11-16', equity: 127680.97 },
  { date: '2022-11-17', equity: 127680.97 },
  { date: '2022-11-18', equity: 127680.97 },
  { date: '2022-11-21', equity: 127824.61 },
  { date: '2022-11-22', equity: 127824.61 },
  { date: '2022-11-23', equity: 127621.84 },
  { date: '2022-11-25', equity: 127621.84 },
  { date: '2022-11-29', equity: 127621.84 },
  { date: '2022-11-30', equity: 127621.84 },
  { date: '2022-12-01', equity: 127766.08 },
  { date: '2022-12-02', equity: 127766.08 },
  { date: '2022-12-05', equity: 127766.08 },
  { date: '2022-12-06', equity: 127766.08 },
  { date: '2022-12-07', equity: 127766.08 },
  { date: '2022-12-08', equity: 127766.08 },
  { date: '2022-12-09', equity: 127766.08 },
  { date: '2022-12-12', equity: 127766.08 },
  { date: '2022-12-13', equity: 127766.08 },
  { date: '2022-12-14', equity: 127766.08 },
  { date: '2022-12-15', equity: 127766.08 },
  { date: '2022-12-19', equity: 128812.28 },
  { date: '2022-12-20', equity: 128812.28 },
  { date: '2022-12-22', equity: 129717.29 },
  { date: '2022-12-23', equity: 129717.29 },
  { date: '2022-12-27', equity: 129875.4 },
  { date: '2022-12-28', equity: 129875.4 },
  { date: '2022-12-29', equity: 129875.4 },
  { date: '2022-12-30', equity: 129875.4 },
  { date: '2023-01-03', equity: 131003.55 },
  { date: '2023-01-04', equity: 131003.55 },
  { date: '2023-01-06', equity: 131003.55 },
  { date: '2023-01-09', equity: 132376.73 },
  { date: '2023-01-11', equity: 132376.73 },
  { date: '2023-01-12', equity: 134480.03 },
  { date: '2023-01-13', equity: 134480.03 },
  { date: '2023-01-16', equity: 134480.03 },
  { date: '2023-01-17', equity: 135692.97 },
  { date: '2023-01-18', equity: 135858.71 },
  { date: '2023-01-19', equity: 134152.34 },
  { date: '2023-01-20', equity: 134152.34 },
  { date: '2023-01-23', equity: 135288.54 },
  { date: '2023-01-24', equity: 135288.54 },
  { date: '2023-01-25', equity: 135288.54 },
  { date: '2023-01-26', equity: 136330.85 },
  { date: '2023-01-27', equity: 138428.85 },
  { date: '2023-01-30', equity: 138464.02 },
  { date: '2023-01-31', equity: 138464.02 },
  { date: '2023-02-01', equity: 138636.06 },
  { date: '2023-02-02', equity: 140492.18 },
  { date: '2023-02-03', equity: 141441.65 },
  { date: '2023-02-06', equity: 140547.73 },
  { date: '2023-02-07', equity: 140547.73 },
  { date: '2023-02-08', equity: 140547.73 },
  { date: '2023-02-09', equity: 140547.73 },
  { date: '2023-02-10', equity: 140547.73 },
  { date: '2023-02-13', equity: 140421.49 },
  { date: '2023-02-14', equity: 140421.49 },
  { date: '2023-02-15', equity: 140421.49 },
  { date: '2023-02-16', equity: 140421.49 },
  { date: '2023-02-17', equity: 140301.49 },
  { date: '2023-02-21', equity: 140470.41 },
  { date: '2023-02-22', equity: 140470.41 },
  { date: '2023-02-23', equity: 140470.41 },
  { date: '2023-02-24', equity: 140470.41 },
  { date: '2023-02-27', equity: 140470.41 },
  { date: '2023-02-28', equity: 140470.41 },
  { date: '2023-03-01', equity: 140470.41 },
  { date: '2023-03-02', equity: 140470.41 },
  { date: '2023-03-03', equity: 140653.87 },
  { date: '2023-03-06', equity: 141626.19 },
  { date: '2023-03-08', equity: 141626.19 },
  { date: '2023-03-09', equity: 140862.03 },
  { date: '2023-03-10', equity: 141045.62 },
  { date: '2023-03-13', equity: 140912.18 },
  { date: '2023-03-14', equity: 140912.18 },
  { date: '2023-03-15', equity: 140912.18 },
  { date: '2023-03-16', equity: 140912.18 },
  { date: '2023-03-20', equity: 139874.6 },
  { date: '2023-03-21', equity: 141127.58 },
  { date: '2023-03-22', equity: 141127.58 },
  { date: '2023-03-23', equity: 141026.31 },
  { date: '2023-03-24', equity: 141026.31 },
  { date: '2023-03-27', equity: 141026.31 },
  { date: '2023-03-28', equity: 141026.31 },
  { date: '2023-03-29', equity: 141026.31 },
  { date: '2023-03-31', equity: 141983.11 },
  { date: '2023-04-03', equity: 141983.11 },
  { date: '2023-04-04', equity: 141983.11 },
  { date: '2023-04-05', equity: 141983.11 },
  { date: '2023-04-06', equity: 141983.11 },
  { date: '2023-04-10', equity: 141063.31 },
  { date: '2023-04-11', equity: 141063.31 },
  { date: '2023-04-12', equity: 141063.31 },
  { date: '2023-04-13', equity: 141063.31 },
  { date: '2023-04-14', equity: 141063.31 },
  { date: '2023-04-17', equity: 141063.31 },
  { date: '2023-04-18', equity: 141063.31 },
  { date: '2023-04-19', equity: 141063.31 },
  { date: '2023-04-20', equity: 141063.31 },
  { date: '2023-04-21', equity: 141063.31 },
  { date: '2023-04-24', equity: 141204.09 },
  { date: '2023-04-25', equity: 140545.22 },
  { date: '2023-04-26', equity: 140545.22 },
  { date: '2023-04-27', equity: 141739.27 },
  { date: '2023-04-28', equity: 141628.14 },
  { date: '2023-05-01', equity: 141628.14 },
  { date: '2023-05-02', equity: 141823.88 },
  { date: '2023-05-03', equity: 140581.5 },
  { date: '2023-05-04', equity: 140581.5 },
  { date: '2023-05-05', equity: 141538.95 },
  { date: '2023-05-08', equity: 141736.52 },
  { date: '2023-05-09', equity: 141736.52 },
  { date: '2023-05-10', equity: 141833.74 },
  { date: '2023-05-11', equity: 141833.74 },
  { date: '2023-05-12', equity: 141833.74 },
  { date: '2023-05-15', equity: 141833.74 },
  { date: '2023-05-16', equity: 143071.63 },
  { date: '2023-05-17', equity: 143071.63 },
  { date: '2023-05-18', equity: 144417.23 },
  { date: '2023-05-19', equity: 144417.23 },
  { date: '2023-05-22', equity: 144128.55 },
  { date: '2023-05-23', equity: 144371.91 },
  { date: '2023-05-24', equity: 143332.65 },
  { date: '2023-05-25', equity: 143332.65 },
  { date: '2023-05-26', equity: 143332.65 },
  { date: '2023-05-30', equity: 145980.44 },
  { date: '2023-05-31', equity: 144639.71 },
  { date: '2023-06-01', equity: 145630.43 },
  { date: '2023-06-02', equity: 145630.43 },
  { date: '2023-06-05', equity: 145630.43 },
  { date: '2023-06-06', equity: 145630.43 },
  { date: '2023-06-07', equity: 145508.05 },
  { date: '2023-06-08', equity: 145508.05 },
  { date: '2023-06-09', equity: 145864.81 },
  { date: '2023-06-12', equity: 145864.81 },
  { date: '2023-06-13', equity: 145915.26 },
  { date: '2023-06-14', equity: 145915.26 },
  { date: '2023-06-15', equity: 146937.59 },
  { date: '2023-06-16', equity: 147124.64 },
  { date: '2023-06-20', equity: 148256.87 },
  { date: '2023-06-22', equity: 148256.87 },
  { date: '2023-06-23', equity: 148256.87 },
  { date: '2023-06-26', equity: 148256.87 },
  { date: '2023-06-27', equity: 148256.87 },
  { date: '2023-06-28', equity: 148256.87 },
  { date: '2023-06-29', equity: 148256.87 },
  { date: '2023-06-30', equity: 149312.95 },
  { date: '2023-07-03', equity: 149536.73 },
  { date: '2023-07-05', equity: 149536.73 },
  { date: '2023-07-06', equity: 149393.58 },
  { date: '2023-07-07', equity: 149393.58 },
  { date: '2023-07-10', equity: 149393.58 },
  { date: '2023-07-11', equity: 148401.18 },
  { date: '2023-07-12', equity: 148401.18 },
  { date: '2023-07-13', equity: 148654.46 },
  { date: '2023-07-14', equity: 148761.85 },
  { date: '2023-07-17', equity: 148960.24 },
  { date: '2023-07-18', equity: 150127.47 },
  { date: '2023-07-19', equity: 150390.87 },
  { date: '2023-07-20', equity: 149523.56 },
  { date: '2023-07-21', equity: 149523.56 },
  { date: '2023-07-24', equity: 149523.56 },
  { date: '2023-07-25', equity: 149523.56 },
  { date: '2023-07-26', equity: 149523.56 },
  { date: '2023-07-27', equity: 149523.56 },
  { date: '2023-07-28', equity: 149012.78 },
  { date: '2023-07-31', equity: 149012.78 },
  { date: '2023-08-01', equity: 149012.78 },
  { date: '2023-08-02', equity: 148836.66 },
  { date: '2023-08-03', equity: 148836.66 },
  { date: '2023-08-04', equity: 148836.66 },
  { date: '2023-08-07', equity: 149893.69 },
  { date: '2023-08-08', equity: 149893.69 },
  { date: '2023-08-09', equity: 149048.34 },
  { date: '2023-08-10', equity: 149048.34 },
  { date: '2023-08-11', equity: 149048.34 },
  { date: '2023-08-14', equity: 149048.34 },
  { date: '2023-08-15', equity: 149048.34 },
  { date: '2023-08-16', equity: 149048.34 },
  { date: '2023-08-17', equity: 149291.4 },
  { date: '2023-08-18', equity: 149877.74 },
  { date: '2023-08-21', equity: 149877.74 },
  { date: '2023-08-22', equity: 151793.09 },
  { date: '2023-08-23', equity: 151793.09 },
  { date: '2023-08-24', equity: 151793.09 },
  { date: '2023-08-28', equity: 152106.11 },
  { date: '2023-08-29', equity: 152106.11 },
  { date: '2023-08-30', equity: 152106.11 },
  { date: '2023-08-31', equity: 152106.11 },
  { date: '2023-09-01', equity: 153198.71 },
  { date: '2023-09-05', equity: 153198.71 },
  { date: '2023-09-06', equity: 152374.24 },
  { date: '2023-09-07', equity: 154050.21 },
  { date: '2023-09-08', equity: 154050.21 },
  { date: '2023-09-12', equity: 154295.57 },
  { date: '2023-09-13', equity: 154295.57 },
  { date: '2023-09-15', equity: 154295.57 },
  { date: '2023-09-19', equity: 154295.57 },
  { date: '2023-09-21', equity: 154603.58 },
  { date: '2023-09-22', equity: 154603.58 },
  { date: '2023-09-25', equity: 154603.58 },
  { date: '2023-09-26', equity: 155759.98 },
  { date: '2023-09-27', equity: 156944.87 },
  { date: '2023-09-28', equity: 157046.2 },
  { date: '2023-09-29', equity: 157341.4 },
  { date: '2023-10-02', equity: 156509.69 },
  { date: '2023-10-03', equity: 156260.09 },
  { date: '2023-10-04', equity: 156260.09 },
  { date: '2023-10-05', equity: 156508.3 },
  { date: '2023-10-06', equity: 156508.3 },
  { date: '2023-10-09', equity: 156508.3 },
  { date: '2023-10-10', equity: 156904.46 },
  { date: '2023-10-11', equity: 156904.46 },
  { date: '2023-10-12', equity: 156904.46 },
  { date: '2023-10-13', equity: 156686.44 },
  { date: '2023-10-16', equity: 156686.44 },
  { date: '2023-10-17', equity: 155573.7 },
  { date: '2023-10-18', equity: 156838.39 },
  { date: '2023-10-19', equity: 156838.39 },
  { date: '2023-10-20', equity: 157097.16 },
  { date: '2023-10-23', equity: 157402.85 },
  { date: '2023-10-24', equity: 157402.85 },
  { date: '2023-10-25', equity: 157402.85 },
  { date: '2023-10-26', equity: 157402.85 },
  { date: '2023-10-27', equity: 157720.27 },
  { date: '2023-10-30', equity: 156800.72 },
  { date: '2023-10-31', equity: 156800.72 },
  { date: '2023-11-01', equity: 158042.64 },
  { date: '2023-11-02', equity: 158373.32 },
  { date: '2023-11-03', equity: 158654.85 },
  { date: '2023-11-06', equity: 161136.07 },
  { date: '2023-11-07', equity: 161480.77 },
  { date: '2023-11-08', equity: 162667.45 },
  { date: '2023-11-10', equity: 163028.84 },
  { date: '2023-11-13', equity: 163028.84 },
  { date: '2023-11-14', equity: 166044.41 },
  { date: '2023-11-15', equity: 167564.74 },
  { date: '2023-11-16', equity: 167350.88 },
  { date: '2023-11-17', equity: 167143.4 },
  { date: '2023-11-20', equity: 167519.55 },
  { date: '2023-11-22', equity: 167519.55 },
  { date: '2023-11-24', equity: 167390.52 },
  { date: '2023-11-27', equity: 167390.52 },
  { date: '2023-11-28', equity: 167390.52 },
  { date: '2023-11-29', equity: 167390.52 },
  { date: '2023-11-30', equity: 167390.52 },
  { date: '2023-12-01', equity: 167390.52 },
  { date: '2023-12-04', equity: 167390.52 },
  { date: '2023-12-05', equity: 167783.37 },
  { date: '2023-12-06', equity: 168193.03 },
  { date: '2023-12-07', equity: 168193.03 },
  { date: '2023-12-08', equity: 167045.93 },
  { date: '2023-12-11', equity: 167045.93 },
  { date: '2023-12-12', equity: 167045.93 },
  { date: '2023-12-13', equity: 167045.93 },
  { date: '2023-12-14', equity: 167045.93 },
  { date: '2023-12-18', equity: 167045.93 },
  { date: '2023-12-20', equity: 166844.63 },
  { date: '2023-12-21', equity: 166844.63 },
  { date: '2023-12-22', equity: 166844.63 },
  { date: '2023-12-27', equity: 166844.63 },
  { date: '2023-12-29', equity: 166844.63 },
  { date: '2024-01-02', equity: 165229.05 },
  { date: '2024-01-03', equity: 165657.46 },
  { date: '2024-01-04', equity: 165657.46 },
  { date: '2024-01-05', equity: 165657.46 },
  { date: '2024-01-08', equity: 167098.87 },
  { date: '2024-01-09', equity: 168507.22 },
  { date: '2024-01-10', equity: 168507.22 },
  { date: '2024-01-11', equity: 168507.22 },
  { date: '2024-01-12', equity: 168850.57 },
  { date: '2024-01-16', equity: 170113.43 },
  { date: '2024-01-17', equity: 170407.65 },
  { date: '2024-01-18', equity: 169346.99 },
  { date: '2024-01-19', equity: 170912.6 },
  { date: '2024-01-22', equity: 170912.6 },
  { date: '2024-01-23', equity: 170912.6 },
  { date: '2024-01-24', equity: 172468.88 },
  { date: '2024-01-25', equity: 173260.41 },
  { date: '2024-01-26', equity: 174563.42 },
  { date: '2024-01-29', equity: 174563.42 },
  { date: '2024-01-30', equity: 173150.96 },
  { date: '2024-01-31', equity: 173150.96 },
  { date: '2024-02-01', equity: 173150.96 },
  { date: '2024-02-02', equity: 177273.45 },
  { date: '2024-02-05', equity: 178882.66 },
  { date: '2024-02-06', equity: 178882.66 },
  { date: '2024-02-07', equity: 178882.66 },
  { date: '2024-02-08', equity: 180540.01 },
  { date: '2024-02-09', equity: 180540.01 },
  { date: '2024-02-12', equity: 180228.25 },
  { date: '2024-02-13', equity: 180228.25 },
  { date: '2024-02-14', equity: 180657.52 },
  { date: '2024-02-15', equity: 180657.52 },
  { date: '2024-02-16', equity: 180657.52 },
  { date: '2024-02-19', equity: 180657.52 },
  { date: '2024-02-20', equity: 179653.87 },
  { date: '2024-02-21', equity: 179653.87 },
  { date: '2024-02-22', equity: 179043.32 },
  { date: '2024-02-23', equity: 179043.32 },
  { date: '2024-02-26', equity: 179043.32 },
  { date: '2024-02-28', equity: 179043.32 },
  { date: '2024-02-29', equity: 179043.32 },
  { date: '2024-03-01', equity: 179043.32 },
  { date: '2024-03-04', equity: 180755.23 },
  { date: '2024-03-05', equity: 181107.57 },
  { date: '2024-03-06', equity: 182880.23 },
  { date: '2024-03-07', equity: 182880.23 },
  { date: '2024-03-08', equity: 183293.28 },
  { date: '2024-03-12', equity: 183056.22 },
  { date: '2024-03-13', equity: 183056.22 },
  { date: '2024-03-14', equity: 183385.96 },
  { date: '2024-03-18', equity: 183385.96 },
  { date: '2024-03-20', equity: 183385.96 },
  { date: '2024-03-21', equity: 184794.36 },
  { date: '2024-03-22', equity: 184794.36 },
  { date: '2024-03-25', equity: 184794.36 },
  { date: '2024-03-26', equity: 184794.36 },
  { date: '2024-03-27', equity: 184981.27 },
  { date: '2024-03-28', equity: 184981.27 },
  { date: '2024-04-01', equity: 184981.27 },
  { date: '2024-04-02', equity: 185406.61 },
  { date: '2024-04-03', equity: 185406.61 },
  { date: '2024-04-04', equity: 185406.61 },
  { date: '2024-04-05', equity: 185406.61 },
  { date: '2024-04-08', equity: 186933.89 },
  { date: '2024-04-09', equity: 187267.46 },
  { date: '2024-04-10', equity: 187267.46 },
  { date: '2024-04-11', equity: 187267.46 },
  { date: '2024-04-12', equity: 188446.85 },
  { date: '2024-04-15', equity: 188446.85 },
  { date: '2024-04-16', equity: 187355.12 },
  { date: '2024-04-17', equity: 187355.12 },
  { date: '2024-04-18', equity: 187355.12 },
  { date: '2024-04-19', equity: 187798.11 },
  { date: '2024-04-22', equity: 188346.77 },
  { date: '2024-04-23', equity: 186233.98 },
  { date: '2024-04-24', equity: 185974.83 },
  { date: '2024-04-25', equity: 186328.18 },
  { date: '2024-04-26', equity: 186328.18 },
  { date: '2024-04-29', equity: 187423.56 },
  { date: '2024-04-30', equity: 187108.47 },
  { date: '2024-05-01', equity: 186049.02 },
  { date: '2024-05-02', equity: 186049.02 },
  { date: '2024-05-03', equity: 186049.02 },
  { date: '2024-05-06', equity: 186049.02 },
  { date: '2024-05-07', equity: 186049.02 },
  { date: '2024-05-08', equity: 186049.02 },
  { date: '2024-05-09', equity: 186049.02 },
  { date: '2024-05-10', equity: 186511.25 },
  { date: '2024-05-13', equity: 186511.25 },
  { date: '2024-05-14', equity: 186511.25 },
  { date: '2024-05-15', equity: 187639.7 },
  { date: '2024-05-16', equity: 187639.7 },
  { date: '2024-05-17', equity: 187639.7 },
  { date: '2024-05-20', equity: 187639.7 },
  { date: '2024-05-21', equity: 187639.7 },
  { date: '2024-05-22', equity: 187639.7 },
  { date: '2024-05-23', equity: 187639.7 },
  { date: '2024-05-24', equity: 187639.7 },
  { date: '2024-05-28', equity: 190718.2 },
  { date: '2024-05-29', equity: 192637.89 },
  { date: '2024-05-30', equity: 190877.01 },
  { date: '2024-05-31', equity: 190877.01 },
  { date: '2024-06-03', equity: 190877.01 },
  { date: '2024-06-04', equity: 189824.93 },
  { date: '2024-06-05', equity: 189824.93 },
  { date: '2024-06-06', equity: 192347.86 },
  { date: '2024-06-07', equity: 192347.86 },
  { date: '2024-06-10', equity: 192347.86 },
  { date: '2024-06-11', equity: 193517.39 },
  { date: '2024-06-12', equity: 196676.56 },
  { date: '2024-06-13', equity: 196676.56 },
  { date: '2024-06-14', equity: 198687.76 },
  { date: '2024-06-17', equity: 199189.21 },
  { date: '2024-06-18', equity: 199189.21 },
  { date: '2024-06-20', equity: 198903.71 },
  { date: '2024-06-21', equity: 197287.96 },
  { date: '2024-06-24', equity: 198763.31 },
  { date: '2024-06-25', equity: 198763.31 },
  { date: '2024-06-26', equity: 198763.31 },
  { date: '2024-06-28', equity: 196209.67 },
  { date: '2024-07-01', equity: 196623.26 },
  { date: '2024-07-02', equity: 198262.2 },
  { date: '2024-07-03', equity: 198712.27 },
  { date: '2024-07-04', equity: 198712.27 },
  { date: '2024-07-05', equity: 198712.27 },
  { date: '2024-07-08', equity: 199938.58 },
  { date: '2024-07-09', equity: 199938.58 },
  { date: '2024-07-10', equity: 201676.97 },
  { date: '2024-07-11', equity: 201676.97 },
  { date: '2024-07-12', equity: 201676.97 },
  { date: '2024-07-15', equity: 201320.75 },
  { date: '2024-07-16', equity: 201320.75 },
  { date: '2024-07-17', equity: 202811.02 },
  { date: '2024-07-18', equity: 202811.02 },
  { date: '2024-07-22', equity: 202811.02 },
  { date: '2024-07-23', equity: 202811.02 },
  { date: '2024-07-24', equity: 203345.24 },
  { date: '2024-07-25', equity: 204983.11 },
  { date: '2024-07-26', equity: 204983.11 },
  { date: '2024-07-29', equity: 204983.11 },
  { date: '2024-07-30', equity: 204983.11 },
  { date: '2024-07-31', equity: 207001.57 },
  { date: '2024-08-01', equity: 207001.57 },
  { date: '2024-08-02', equity: 207001.57 },
  { date: '2024-08-05', equity: 224756.71 },
  { date: '2024-08-06', equity: 224756.71 },
  { date: '2024-08-07', equity: 224756.71 },
  { date: '2024-08-08', equity: 223470.02 },
  { date: '2024-08-09', equity: 224094.91 },
  { date: '2024-08-12', equity: 224747.6 },
  { date: '2024-08-13', equity: 224747.6 },
  { date: '2024-08-14', equity: 225033.17 },
  { date: '2024-08-15', equity: 226918.11 },
  { date: '2024-08-16', equity: 227624.7 },
  { date: '2024-08-19', equity: 227624.7 },
  { date: '2024-08-20', equity: 228240.24 },
  { date: '2024-08-21', equity: 228240.24 },
  { date: '2024-08-22', equity: 228240.24 },
  { date: '2024-08-23', equity: 228240.24 },
  { date: '2024-08-26', equity: 226113.19 },
  { date: '2024-08-27', equity: 226113.19 },
  { date: '2024-08-28', equity: 226113.19 },
  { date: '2024-08-29', equity: 227519.19 },
  { date: '2024-08-30', equity: 227519.19 },
  { date: '2024-09-03', equity: 226228.34 },
  { date: '2024-09-04', equity: 229658.71 },
  { date: '2024-09-05', equity: 229260.39 },
  { date: '2024-09-06', equity: 229260.39 },
  { date: '2024-09-09', equity: 229260.39 },
  { date: '2024-09-10', equity: 229260.39 },
  { date: '2024-09-11', equity: 229260.39 },
  { date: '2024-09-13', equity: 229996.28 },
  { date: '2024-09-16', equity: 227830.52 },
  { date: '2024-09-17', equity: 227830.52 },
  { date: '2024-09-19', equity: 228598.18 },
  { date: '2024-09-20', equity: 228598.18 },
  { date: '2024-09-23', equity: 228598.18 },
  { date: '2024-09-24', equity: 229256.26 },
  { date: '2024-09-25', equity: 229256.26 },
  { date: '2024-09-26', equity: 229256.26 },
  { date: '2024-09-27', equity: 229256.26 },
  { date: '2024-09-30', equity: 229256.26 },
  { date: '2024-10-01', equity: 229256.26 },
  { date: '2024-10-02', equity: 229256.26 },
  { date: '2024-10-03', equity: 230057.03 },
  { date: '2024-10-04', equity: 230057.03 },
  { date: '2024-10-07', equity: 230057.03 },
  { date: '2024-10-08', equity: 230894.13 },
  { date: '2024-10-09', equity: 230894.13 },
  { date: '2024-10-10', equity: 230894.13 },
  { date: '2024-10-11', equity: 230894.13 },
  { date: '2024-10-14', equity: 233460.8 },
  { date: '2024-10-15', equity: 232656.85 },
  { date: '2024-10-16', equity: 233530.3 },
  { date: '2024-10-18', equity: 233530.3 },
  { date: '2024-10-21', equity: 233530.3 },
  { date: '2024-10-22', equity: 235311.14 },
  { date: '2024-10-23', equity: 234018.34 },
  { date: '2024-10-24', equity: 234599.89 },
  { date: '2024-10-25', equity: 235204.95 },
  { date: '2024-10-28', equity: 234763.66 },
  { date: '2024-10-29', equity: 234763.66 },
  { date: '2024-10-31', equity: 234763.66 },
  { date: '2024-11-01', equity: 234763.66 },
  { date: '2024-11-04', equity: 235377.29 },
  { date: '2024-11-05', equity: 235377.29 },
  { date: '2024-11-06', equity: 238877.8 },
  { date: '2024-11-07', equity: 240270.49 },
  { date: '2024-11-08', equity: 242832.37 },
  { date: '2024-11-11', equity: 245212.49 },
  { date: '2024-11-12', equity: 243792.05 },
  { date: '2024-11-13', equity: 244880.25 },
  { date: '2024-11-14', equity: 244880.25 },
  { date: '2024-11-15', equity: 245931.73 },
  { date: '2024-11-18', equity: 245344.76 },
  { date: '2024-11-19', equity: 245344.76 },
  { date: '2024-11-20', equity: 245344.76 },
  { date: '2024-11-22', equity: 245344.76 },
  { date: '2024-11-25', equity: 246714.07 },
  { date: '2024-11-26', equity: 248624.72 },
  { date: '2024-11-27', equity: 248624.72 },
  { date: '2024-11-29', equity: 248624.72 },
  { date: '2024-12-02', equity: 248624.72 },
  { date: '2024-12-03', equity: 248624.72 },
  { date: '2024-12-04', equity: 250605.01 },
  { date: '2024-12-05', equity: 250605.01 },
  { date: '2024-12-06', equity: 253751.91 },
  { date: '2024-12-09', equity: 256647.17 },
  { date: '2024-12-10', equity: 258930.09 },
  { date: '2024-12-11', equity: 259836.11 },
  { date: '2024-12-13', equity: 259836.11 },
  { date: '2024-12-16', equity: 260781.04 },
  { date: '2024-12-17', equity: 261766.14 },
  { date: '2024-12-18', equity: 258878.15 },
  { date: '2024-12-19', equity: 258878.15 },
  { date: '2024-12-20', equity: 258878.15 },
  { date: '2024-12-23', equity: 258878.15 },
  { date: '2024-12-24', equity: 258878.15 },
  { date: '2024-12-26', equity: 258878.15 },
  { date: '2024-12-27', equity: 258878.15 },
  { date: '2024-12-30', equity: 258878.15 },
  { date: '2024-12-31', equity: 259845.63 },
  { date: '2025-01-02', equity: 260354.19 },
  { date: '2025-01-06', equity: 260354.19 },
  { date: '2025-01-07', equity: 258242.08 },
  { date: '2025-01-08', equity: 258517.53 },
  { date: '2025-01-10', equity: 258526.67 },
  { date: '2025-01-13', equity: 260039.53 },
  { date: '2025-01-14', equity: 261144.36 },
  { date: '2025-01-15', equity: 261144.36 },
  { date: '2025-01-16', equity: 261144.36 },
  { date: '2025-01-17', equity: 261144.36 },
  { date: '2025-01-21', equity: 265401.06 },
  { date: '2025-01-22', equity: 266692.62 },
  { date: '2025-01-23', equity: 266692.62 },
  { date: '2025-01-24', equity: 265991.43 },
  { date: '2025-01-27', equity: 268195.2 },
  { date: '2025-01-28', equity: 266088.5 },
  { date: '2025-01-29', equity: 266088.5 },
  { date: '2025-01-30', equity: 266088.5 },
  { date: '2025-01-31', equity: 267987.44 },
  { date: '2025-02-03', equity: 267987.44 },
  { date: '2025-02-04', equity: 267006.5 },
  { date: '2025-02-05', equity: 267006.5 },
  { date: '2025-02-06', equity: 267006.5 },
  { date: '2025-02-07', equity: 268370.01 },
  { date: '2025-02-10', equity: 267378.62 },
  { date: '2025-02-11', equity: 267378.62 },
  { date: '2025-02-12', equity: 267378.62 },
  { date: '2025-02-13', equity: 267378.62 },
  { date: '2025-02-14', equity: 268509.5 },
  { date: '2025-02-17', equity: 268509.5 },
  { date: '2025-02-18', equity: 268509.5 },
  { date: '2025-02-19', equity: 270004.74 },
  { date: '2025-02-20', equity: 268996.24 },
  { date: '2025-02-21', equity: 268996.24 },
  { date: '2025-02-24', equity: 267951.6 },
  { date: '2025-02-25', equity: 271418.36 },
  { date: '2025-02-26', equity: 269151.08 },
  { date: '2025-02-27', equity: 271635.95 },
  { date: '2025-02-28', equity: 271635.95 },
  { date: '2025-03-03', equity: 271635.95 },
  { date: '2025-03-04', equity: 268866.78 },
  { date: '2025-03-05', equity: 268866.78 },
  { date: '2025-03-06', equity: 268866.78 },
  { date: '2025-03-07', equity: 268866.78 },
  { date: '2025-03-10', equity: 271428.95 },
  { date: '2025-03-11', equity: 273026.54 },
  { date: '2025-03-12', equity: 274675.87 },
  { date: '2025-03-13', equity: 274675.87 },
  { date: '2025-03-14', equity: 274675.87 },
  { date: '2025-03-18', equity: 274675.87 },
  { date: '2025-03-20', equity: 274675.87 },
  { date: '2025-03-21', equity: 274675.87 },
  { date: '2025-03-24', equity: 274675.87 },
  { date: '2025-03-25', equity: 275807.25 },
  { date: '2025-03-26', equity: 276436.24 },
  { date: '2025-03-27', equity: 276436.24 },
  { date: '2025-03-28', equity: 276436.24 },
  { date: '2025-03-31', equity: 276436.24 },
  { date: '2025-04-01', equity: 276436.24 },
  { date: '2025-04-02', equity: 276436.24 },
  { date: '2025-04-03', equity: 276436.24 },
  { date: '2025-04-04', equity: 289439.6 },
  { date: '2025-04-07', equity: 298569.09 },
  { date: '2025-04-08', equity: 298569.09 },
  { date: '2025-04-10', equity: 298569.09 },
  { date: '2025-04-11', equity: 298569.09 },
  { date: '2025-04-14', equity: 298569.09 },
  { date: '2025-04-16', equity: 298569.09 },
  { date: '2025-04-21', equity: 300973.35 },
  { date: '2025-04-22', equity: 300973.35 },
  { date: '2025-04-23', equity: 299344.22 },
  { date: '2025-04-24', equity: 301012.62 },
  { date: '2025-04-25', equity: 303985.74 },
  { date: '2025-04-28', equity: 306800.73 },
  { date: '2025-04-29', equity: 306800.73 },
  { date: '2025-04-30', equity: 305423.51 },
  { date: '2025-05-01', equity: 305423.51 },
  { date: '2025-05-02', equity: 305423.51 },
  { date: '2025-05-05', equity: 305423.51 },
  { date: '2025-05-06', equity: 305423.51 },
  { date: '2025-05-07', equity: 304084.25 },
  { date: '2025-05-08', equity: 304084.25 },
  { date: '2025-05-09', equity: 304084.25 },
  { date: '2025-05-12', equity: 307303.9 },
  { date: '2025-05-13', equity: 311002.07 },
  { date: '2025-05-14', equity: 314924.28 },
  { date: '2025-05-15', equity: 312476.14 },
  { date: '2025-05-16', equity: 312476.14 },
  { date: '2025-05-19', equity: 309240.95 },
  { date: '2025-05-20', equity: 309240.95 },
  { date: '2025-05-21', equity: 311773.47 },
  { date: '2025-05-22', equity: 311773.47 },
  { date: '2025-05-23', equity: 311773.47 },
  { date: '2025-05-26', equity: 311773.47 },
  { date: '2025-05-27', equity: 313281.1 },
  { date: '2025-05-28', equity: 313281.1 },
  { date: '2025-05-29', equity: 317356.87 },
  { date: '2025-05-30', equity: 316260.29 },
  { date: '2025-06-02', equity: 316260.29 },
  { date: '2025-06-03', equity: 316260.29 },
  { date: '2025-06-05', equity: 317784.75 },
  { date: '2025-06-06', equity: 318203.95 },
  { date: '2025-06-09', equity: 318203.95 },
  { date: '2025-06-10', equity: 318203.95 },
  { date: '2025-06-11', equity: 319999.39 },
  { date: '2025-06-12', equity: 319999.39 },
  { date: '2025-06-13', equity: 319999.39 },
  { date: '2025-06-16', equity: 319999.39 },
  { date: '2025-06-17', equity: 319999.39 },
  { date: '2025-06-18', equity: 319999.39 },
  { date: '2025-06-20', equity: 319999.39 },
  { date: '2025-06-23', equity: 319999.39 },
  { date: '2025-06-24', equity: 319999.39 },
  { date: '2025-06-25', equity: 322753.06 },
  { date: '2025-06-26', equity: 322753.06 },
  { date: '2025-06-27', equity: 330156.72 },
  { date: '2025-06-30', equity: 330156.72 },
  { date: '2025-07-01', equity: 330156.72 },
  { date: '2025-07-02', equity: 330156.72 },
  { date: '2025-07-03', equity: 332036.33 },
  { date: '2025-07-04', equity: 332036.33 },
  { date: '2025-07-07', equity: 332036.33 },
  { date: '2025-07-08', equity: 330913.8 },
  { date: '2025-07-09', equity: 329162.43 },
  { date: '2025-07-10', equity: 329162.43 },
  { date: '2025-07-11', equity: 329162.43 },
  { date: '2025-07-14', equity: 331115.66 },
  { date: '2025-07-15', equity: 331115.66 },
  { date: '2025-07-16', equity: 331115.66 },
  { date: '2025-07-17', equity: 331115.66 },
  { date: '2025-07-18', equity: 331115.66 },
  { date: '2025-07-21', equity: 331115.66 },
  { date: '2025-07-22', equity: 331115.66 },
  { date: '2025-07-23', equity: 331115.66 },
  { date: '2025-07-24', equity: 333492.54 },
  { date: '2025-07-25', equity: 333492.54 },
  { date: '2025-07-28', equity: 333492.54 },
  { date: '2025-07-29', equity: 333492.54 },
  { date: '2025-07-31', equity: 333492.54 },
  { date: '2025-08-01', equity: 333492.54 },
  { date: '2025-08-04', equity: 333492.54 },
  { date: '2025-08-05', equity: 333492.54 },
  { date: '2025-08-06', equity: 334969.39 },
  { date: '2025-08-07', equity: 339588.26 },
  { date: '2025-08-08', equity: 345195.17 },
  { date: '2025-08-11', equity: 346822.24 },
  { date: '2025-08-12', equity: 345637.47 },
  { date: '2025-08-13', equity: 345637.47 },
  { date: '2025-08-14', equity: 344091.52 },
  { date: '2025-08-15', equity: 344091.52 },
  { date: '2025-08-18', equity: 344091.52 },
  { date: '2025-08-19', equity: 346239.15 },
  { date: '2025-08-20', equity: 349017.86 },
  { date: '2025-08-21', equity: 347874.44 },
  { date: '2025-08-22', equity: 350263.67 },
  { date: '2025-08-25', equity: 350263.67 },
  { date: '2025-08-26', equity: 352757.22 },
  { date: '2025-08-27', equity: 352757.22 },
  { date: '2025-08-28', equity: 352757.22 },
  { date: '2025-08-29', equity: 351608.1 },
  { date: '2025-09-02', equity: 351608.1 },
  { date: '2025-09-03', equity: 353937.07 },
  { date: '2025-09-05', equity: 356875.51 },
  { date: '2025-09-08', equity: 356875.51 },
  { date: '2025-09-09', equity: 356875.51 },
  { date: '2025-09-10', equity: 355036.86 },
  { date: '2025-09-11', equity: 355036.86 },
  { date: '2025-09-12', equity: 353093.37 },
  { date: '2025-09-15', equity: 356196.94 },
  { date: '2025-09-16', equity: 356196.94 },
  { date: '2025-09-17', equity: 356687.28 },
  { date: '2025-09-18', equity: 356687.28 },
  { date: '2025-09-19', equity: 359287.22 },
  { date: '2025-09-22', equity: 361373.89 },
  { date: '2025-09-23', equity: 359480.39 },
  { date: '2025-09-24', equity: 359480.39 },
  { date: '2025-09-25', equity: 359480.39 },
  { date: '2025-09-26', equity: 359480.39 },
  { date: '2025-09-29', equity: 361313.69 },
  { date: '2025-09-30', equity: 361313.69 },
  { date: '2025-10-01', equity: 361313.69 },
  { date: '2025-10-02', equity: 359988.37 },
  { date: '2025-10-03', equity: 362619 },
  { date: '2025-10-07', equity: 362619 },
  { date: '2025-10-08', equity: 362619 },
  { date: '2025-10-09', equity: 362619 },
  { date: '2025-10-10', equity: 358617.09 },
  { date: '2025-10-13', equity: 358617.09 },
  { date: '2025-10-14', equity: 361360.13 },
  { date: '2025-10-15', equity: 361360.13 },
  { date: '2025-10-16', equity: 361360.13 },
  { date: '2025-10-17', equity: 363567.81 },
  { date: '2025-10-20', equity: 365499.27 },
  { date: '2025-10-21', equity: 365499.27 },
  { date: '2025-10-22', equity: 365499.27 },
  { date: '2025-10-23', equity: 365499.27 },
  { date: '2025-10-24', equity: 365499.27 },
  { date: '2025-10-27', equity: 367496.08 },
  { date: '2025-10-29', equity: 374243.56 },
  { date: '2025-10-30', equity: 371453.91 },
  { date: '2025-10-31', equity: 378377.93 },
  { date: '2025-11-03', equity: 387132.57 },
  { date: '2025-11-04', equity: 385122.27 },
  { date: '2025-11-05', equity: 385122.27 },
  { date: '2025-11-06', equity: 388232.91 },
  { date: '2025-11-07', equity: 391480.1 },
  { date: '2025-11-10', equity: 391480.1 },
  { date: '2025-11-11', equity: 391480.1 },
  { date: '2025-11-12', equity: 391480.1 },
  { date: '2025-11-13', equity: 391480.1 },
  { date: '2025-11-14', equity: 393322.35 },
  { date: '2025-11-17', equity: 393322.35 },
  { date: '2025-11-18', equity: 393322.35 },
  { date: '2025-11-19', equity: 393322.35 },
  { date: '2025-11-20', equity: 400261.5 },
  { date: '2025-11-21', equity: 400724.18 },
  { date: '2025-11-24', equity: 400724.18 },
  { date: '2025-11-25', equity: 402787.01 },
  { date: '2025-11-26', equity: 402787.01 },
  { date: '2025-11-28', equity: 402787.01 },
  { date: '2025-12-01', equity: 402787.01 },
  { date: '2025-12-02', equity: 402787.01 },
  { date: '2025-12-03', equity: 402787.01 },
  { date: '2025-12-05', equity: 402787.01 },
  { date: '2025-12-08', equity: 402787.01 },
  { date: '2025-12-09', equity: 402787.01 },
  { date: '2025-12-10', equity: 406526.37 },
  { date: '2025-12-11', equity: 405494.57 },
  { date: '2025-12-12', equity: 407416.1 },
  { date: '2025-12-15', equity: 407416.1 },
  { date: '2025-12-16', equity: 407416.1 },
  { date: '2025-12-17', equity: 409419.31 },
  { date: '2025-12-18', equity: 411515.08 },
  { date: '2025-12-19', equity: 411515.08 },
  { date: '2025-12-22', equity: 411515.08 },
  { date: '2025-12-23', equity: 411515.08 },
  { date: '2025-12-24', equity: 411515.08 },
  { date: '2025-12-29', equity: 411515.08 },
  { date: '2025-12-30', equity: 411515.08 },
  { date: '2025-12-31', equity: 411515.08 },
  { date: '2026-01-02', equity: 415207.89 },
  { date: '2026-01-05', equity: 415207.89 },
  { date: '2026-01-06', equity: 416671.5 },
  { date: '2026-01-07', equity: 416671.5 },
  { date: '2026-01-08', equity: 413983.86 },
  { date: '2026-01-09', equity: 413983.86 },
  { date: '2026-01-12', equity: 411149.99 },
  { date: '2026-01-13', equity: 411417.49 },
  { date: '2026-01-14', equity: 411417.49 },
  { date: '2026-01-16', equity: 411417.49 },
  { date: '2026-01-20', equity: 414554.51 },
  { date: '2026-01-21', equity: 414554.51 },
  { date: '2026-01-22', equity: 414554.51 },
  { date: '2026-01-23', equity: 414554.51 },
  { date: '2026-01-26', equity: 414554.51 },
  { date: '2026-01-27', equity: 414554.51 },
  { date: '2026-01-28', equity: 414554.51 },
  { date: '2026-01-29', equity: 414554.51 },
  { date: '2026-01-30', equity: 414554.51 },
  { date: '2026-02-02', equity: 416765.54 },
  { date: '2026-02-03', equity: 416765.54 },
  { date: '2026-02-04', equity: 422028.41 },
  { date: '2026-02-05', equity: 425762.2 },
  { date: '2026-02-06', equity: 433484.64 },
  { date: '2026-02-09', equity: 436605.78 },
  { date: '2026-02-10', equity: 436605.78 },
  { date: '2026-02-11', equity: 436605.78 },
  { date: '2026-02-12', equity: 435461.66 },
  { date: '2026-02-13', equity: 435461.66 },
  { date: '2026-02-16', equity: 435461.66 },
  { date: '2026-02-18', equity: 435461.66 },
  { date: '2026-02-19', equity: 435461.66 },
  { date: '2026-02-20', equity: 435461.66 },
  { date: '2026-02-23', equity: 435461.66 },
  { date: '2026-02-24', equity: 433424.91 },
  { date: '2026-02-25', equity: 433424.91 },
  { date: '2026-02-26', equity: 433424.91 },
  { date: '2026-02-27', equity: 436652.42 },
  { date: '2026-03-02', equity: 436652.42 },
  { date: '2026-03-03', equity: 433931.49 },
  { date: '2026-03-04', equity: 433931.49 },
  { date: '2026-03-05', equity: 433931.49 },
  { date: '2026-03-06', equity: 437707.17 },
  { date: '2026-03-09', equity: 437707.17 },
  { date: '2026-03-10', equity: 437707.17 },
  { date: '2026-03-11', equity: 437707.17 },
  { date: '2026-03-12', equity: 437707.17 },
  { date: '2026-03-13', equity: 437707.17 },
  { date: '2026-03-16', equity: 437707.17 },
  { date: '2026-03-17', equity: 437707.17 },
  { date: '2026-03-18', equity: 437707.17 },
  { date: '2026-03-19', equity: 437707.17 },
  { date: '2026-03-20', equity: 437707.17 },
  { date: '2026-03-23', equity: 437707.17 },
  { date: '2026-03-24', equity: 437707.17 },
  { date: '2026-03-25', equity: 437707.17 },
  { date: '2026-03-26', equity: 437707.17 },
  { date: '2026-03-27', equity: 437707.17 },
  { date: '2026-03-30', equity: 444977.07 },
  { date: '2026-03-31', equity: 444977.07 },
  { date: '2026-04-01', equity: 447004.04 },
  { date: '2026-04-02', equity: 447004.04 },
  { date: '2026-04-06', equity: 445018.27 },
  { date: '2026-04-07', equity: 445018.27 },
  { date: '2026-04-08', equity: 445018.27 },
  { date: '2026-04-09', equity: 448480.79 },
  { date: '2026-04-10', equity: 452067.95 },
  { date: '2026-04-13', equity: 452067.95 },
  { date: '2026-04-14', equity: 459225.89 },
  { date: '2026-04-15', equity: 461339.99 },
  { date: '2026-04-17', equity: 469002.55 },
  { date: '2026-04-20', equity: 468436.38 },
  { date: '2026-04-21', equity: 464986.71 },
  { date: '2026-04-22', equity: 464986.71 },
  { date: '2026-04-23', equity: 463493.57 },
  { date: '2026-04-24', equity: 463493.57 },
  { date: '2026-04-27', equity: 460500.23 },
  { date: '2026-04-28', equity: 460500.23 },
  { date: '2026-04-29', equity: 460500.23 },
  { date: '2026-05-01', equity: 462678.23 },
  { date: '2026-05-04', equity: 460632.39 },
  { date: '2026-05-05', equity: 455907.25 },
  { date: '2026-05-06', equity: 459861.73 },
  { date: '2026-05-07', equity: 463537.72 },
  { date: '2026-05-08', equity: 463537.72 },
  { date: '2026-05-11', equity: 469406.5 },
  { date: '2026-05-12', equity: 464390.24 },
  { date: '2026-05-13', equity: 466575.08 },
  { date: '2026-05-14', equity: 466575.08 },
  { date: '2026-05-15', equity: 461278.78 },
  { date: '2026-05-18', equity: 461278.78 },
  { date: '2026-05-19', equity: 461278.78 },
  { date: '2026-05-20', equity: 461278.78 },
  { date: '2026-05-22', equity: 461278.78 },
  { date: '2026-05-27', equity: 461278.78 },
  { date: '2026-05-29', equity: 461278.78 },
  { date: '2026-06-01', equity: 461278.78 },
  { date: '2026-06-02', equity: 458397.69 },
  { date: '2026-06-03', equity: 458397.69 },
  { date: '2026-06-04', equity: 458397.69 },
  { date: '2026-06-05', equity: 458397.69 },
  { date: '2026-06-08', equity: 455870.97 },
  { date: '2026-06-09', equity: 458090.4 },
  { date: '2026-06-10', equity: 461782.7 },
  { date: '2026-06-12', equity: 461108.59 },
  { date: '2026-06-15', equity: 461108.59 },
  { date: '2026-06-16', equity: 461108.59 },
  { date: '2026-06-18', equity: 461108.59 },
];
